<template>
  <el-dialog
    title="查看备注信息"
    :visible.sync="remarkDialog"
    top="29vh"
    width="500px"
    custom-class="custom-dialog"
    :lock-scroll="false"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <div class="content">
      <el-scrollbar>
        <div class="no-data" v-if="dataList && dataList.length === 0">
          无备注信息
        </div>
        <ul class="list" v-else>
          <li v-for="(item, index) in dataList" :key="index">
            <h4>{{ item.createTime }}</h4>
            <p>
              {{ item.description }}
            </p>
          </li>
        </ul>
      </el-scrollbar>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    projectRelationId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      remarkDialog: true,
      dataList: null
    };
  },
  created() {
    this.loadList();
  },
  methods: {
    // 关闭弹框后回调
    closeDialog() {
      // 传递关闭上一级
      this.$emit("close", true);
      // this.$emit("complete", true);
    },

    loadList() {
      this.$api("project", "retrieveRemark", {
        projectRelationId: this.projectRelationId,
        pageIndex: 1,
        pageSize: 10000
      }).then((res) => {
        this.dataList = res.dataList;
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .custom-dialog {
  .el-dialog__body {
    padding: 20px;
  }
  .content {
    height: 240px;
    .list {
      margin: 0 30px;
      li {
        padding: 10px 20px 9px;
        line-height: 20px;
        border-bottom: 1px solid #e6e6e6;
        &:first-child {
          padding-top: 0;
        }
        h4 {
          position: relative;
          font-weight: normal;
          &::before {
            content: "";
            left: -24px;
            top: 6px;
            position: absolute;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: @mainColor;
          }
        }
      }
    }
    .no-data {
      line-height: 240px;
      text-align: center;
    }
  }
}
</style>
